import { createSlice } from '@reduxjs/toolkit';
import { DynamoConnector } from '../../DynamoConnector';

export const metaSlice = createSlice({
    name: 'meta',
    initialState: {
        metaBlob: {},
        error: null,
    },
    reducers: {
        setMetaList: (state, action) => {
            state.metaBlob = action.payload;
            state.error = null;
        },
        setMetaError: (state, action) => {
            state.error = action.payload;
        },
        setMetaFetchingTrue: (state, action) => {
            state.error = null;
            if (action?.payload?.isReload) {
                state.metaBlob = {};
            }
        },
    },
});

export const { setMetaList, setMetaError, setMetaFetchingTrue } = metaSlice.actions;

export const fetchMetaList =
    (isReload = false) =>
    (dispatch) => {
        dispatch(setMetaFetchingTrue({ isReload }));

        DynamoConnector.getCEDHMeta((results) => {
            if (results?.error) {
                dispatch(setMetaError(results.error));
                return;
            }
            dispatch(setMetaList({ ...results }));
        });
    };

export default metaSlice.reducer;
